export enum MenuSelection {
  HOURS,
  LOCATION,
  ORDER,
  CATERING,
  MENU,
}
